import { getWebApp } from './telegram';

export function openTelegramUrl(url?: string | null) {
  const target = String(url || '').trim();
  if (!target) return;

  const tg = getWebApp();
  if (tg) {
    try {
      if (/^https?:\/\/t\.me\//i.test(target) && typeof (tg as any).openTelegramLink === 'function') {
        (tg as any).openTelegramLink(target);
        return;
      }
      if (typeof (tg as any).openLink === 'function') {
        (tg as any).openLink(target);
        return;
      }
    } catch {
      // fall through
    }
  }

  if (/^tg:\/\//i.test(target)) {
    window.location.href = target;
    return;
  }

  window.open(target, '_blank', 'noopener,noreferrer');
}

export function buildTelegramChatUrl(rawInput?: string | null, normalizedLink?: string | null) {
  const raw = String(rawInput || '').trim();
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = String(normalizedLink || '').trim();
  if (!normalized) return null;
  if (normalized.startsWith('@')) return `https://t.me/${normalized.slice(1)}`;
  if (normalized.startsWith('+')) return `https://t.me/${normalized}`;
  return `https://t.me/${normalized}`;
}

export function buildTelegramMessageUrl(params: {
  chatUrl?: string | null;
  tgChatId?: string | null;
  tgMessageId?: string | null;
}) {
  const messageId = String(params.tgMessageId || '').trim();
  if (!messageId) return null;

  const chatUrl = String(params.chatUrl || '').trim().replace(/\/+$/, '');
  if (/^https?:\/\/t\.me\/[^/+][^/]*$/i.test(chatUrl)) {
    return `${chatUrl}/${messageId}`;
  }

  const internalChatId = String(params.tgChatId || '').trim();
  if (internalChatId) {
    return `https://t.me/c/${internalChatId}/${messageId}`;
  }

  return null;
}
